import PropTypes from 'prop-types'
import { Component } from 'react'

export default class ClickableIcon extends Component<any, any> {
  static displayName = 'ClickableIcon'

  static propTypes = {
    callback: PropTypes.func.isRequired,
    parameter: PropTypes.any,
    render: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired
  }

  static defaultProps = {
    parameter: null
  }

  onClick = () => {
    return this.props.callback(this.props.parameter)
  }

  render() {
    const WrappedComponent = this.props.render

    return <WrappedComponent onClick={this.onClick} />
  }
}
